import * as React from "react"
import { graphql } from "gatsby"
import SearchTemplate from "../../../templates/search-results-template"
import { navigate } from "@reach/router"
import SeoResult from "../../../components/seoResult"
import {
  milesToMeter,
  isAreaMatch,
  getLatLan,
} from "../../../components/utils/property-search"
import { hyphenToCaptilize } from "../../../components/utils/property-search"

import _ from "lodash"
import $ from "jquery"

const initConf = {
  hitsPerPage: 20,
  removeWordsIfNoResults: "lastWords",
}

const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME

class Search extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isReady: false,
      query: "blackwater-newport-isle-of-wight",
      min: "",
      max: "",
      bedrooms: "",
      bedrooms_slug: "",
      building: "",
      sortBy: "",
      selectedpromotions: "",
      insideBoundingBox: [],
      aroundLatLng: "",
      aroundRadius: "all",
      getRankingInfo: false,
      searchType: "sales",
      department: "residential",
      popular: "",
      page: "",
      mapView: false,
      backenable: false,
      maploaded: false,
      radius: 3,
      searchState: {},
      algoliaConfig: initConf,
      areaList: props.data?.allArea?.nodes,
      searchCounty: "",
      sortbyslug: "",
    }
  }
  changeStateAndUrl = searchState => {
    if (!this.state.isReady) return; //  block until ready
    let urls = []
    var localQuery = localStorage.getItem("searchValue")
    if (localQuery !== null) {
      searchState.query = localQuery
    }

    if (typeof searchState.query !== "undefined") {
      if (searchState.query !== "") {
        urls.push(`in-${searchState.query}`)
        this.setState({ query: searchState.query })
      } else {
        urls.push(``)
        this.setState({ query: searchState.query })
      }
    } else {
      if (this.state.query !== "") {
        urls.push(`in-${this.state.query}`)
        this.setState({ query: this.state.query })
      } else {
        urls.push(``)
        this.setState({ query: this.state.query })
      }
    }

    if (typeof searchState.property_promotions !== "undefined") {
      if (searchState.property_promotions.length > 0) {
        var promo = []

        searchState.property_promotions.forEach((item, index) => {
          this.props.data?.allPromotion.nodes.forEach((node, index) => {
            if (item) {
              if (String(node.promo_id) == item) {
                var pro_title = _.lowerCase(node.title)
                promo.push(
                  pro_title.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-")
                )
              }
            }
          })
        })

        urls.push(`with-${promo.join("-and-")}`)
        this.setState({
          property_promotions: searchState.property_promotions,
        })
        this.setState({ selectedpromotions: promo.join("-and-") })
      } else{
        this.setState({ property_promotions: [] })
      }
    } else if (this.state.selectedpromotions && searchState?.selectedpromotions !== "reset") {
      urls.push(`with-${this.state.selectedpromotions}`)
    } else if (typeof searchState.property_promotions === "undefined") {
      this.setState({ property_promotions: [] })
    }

    if (typeof searchState.menu !== "undefined") {
      if (searchState.menu.searchBuilding) {
        urls.push(`type-${searchState.menu.searchBuilding}`)
        this.setState({ building: searchState.menu.searchBuilding })
      } else {
        this.setState({ building: "" })
      }
      if (searchState.menu.accomadation_summary) {
        this.setState({ popular: searchState.menu.accomadation_summary })
      }
    } else if (this.state.building !== "") {
      urls.push(`type-${this.state.building}`)
    }

    if (typeof searchState.range !== "undefined" && searchState.range.bedroom) {
      let bedroom = searchState.range.bedroom.min
      let bedroom_max = searchState.range.bedroom.max
      if (Number(bedroom)) {
        urls.push(`${bedroom}-and-more-bedrooms`)
        this.setState({ bedrooms: bedroom, bedrooms_slug: "" })
      } else if (bedroom_max == 0) {
        urls.push(`studio`)
        this.setState({ bedrooms: bedroom_max, bedrooms_slug: "studio" })
      } else {
        this.setState({ bedrooms: "", bedrooms_slug: "" })
      }
    } else if (this.state.bedrooms_slug) {
        urls.push(`studio`)
    } else if (this.state.bedrooms > 0) {
        urls.push(`${this.state.bedrooms}-and-more-bedrooms`)
    }

    if (
      typeof searchState.range !== "undefined" &&
      typeof searchState.range.price !== "undefined"
    ) {
      let price = searchState.range.price
      let min = price.min
      let max = price.max
      if (min && max) {
        urls.push(`between-${min}-and-${max}`)
        this.setState({ min, max })
      } else {
        if (min) {
          urls.push(`over-${min}`)
          this.setState({ min })
        } else if (this.state.min !== "") {
          this.setState({ min: "" })
        }
        if (max) {
          urls.push(`under-${max}`)
          this.setState({ max })
        } else if (this.state.max !== "") {
          this.setState({ max: "" })
        }
      }
    } else {
      let min = this.state.min
      let max = this.state.max
      if (min !== "" && max !== "") {
        urls.push(`between-${min}-and-${max}`)
        this.setState({ min, max })
      } else {
        if (min) {
          urls.push(`over-${min}`)
          this.setState({ min })
        }
        if (max) {
          urls.push(`under-${max}`)
          this.setState({ max })
        }
      }
    }

    var isMatched = false
    if (!_.isEmpty(searchState.query) && this.state.radius != "") {
      let selectedArea = isAreaMatch(this.state.areaList, searchState.query)
      if (!_.isEmpty(selectedArea) && this.state.radius != "") {
        isMatched = true
        this.setState({ aroundLatLng: getLatLan(selectedArea) })
        this.setState({ aroundRadius: milesToMeter(this.state.radius) })
        this.setState({ getRankingInfo: true })

        if(urls.includes(`in-blackwater-newport-isle-of-wight`))
          urls.push(`radius-8-miles`)
        else
          urls.push(`radius-${this.state.radius}-miles`)

      } else {
        isMatched = false
        this.setState({ algoliaConfig: initConf })
      }
    } else {
      isMatched = false
      this.setState({ algoliaConfig: initConf })
    }

    if (typeof searchState.insideBoundingBox !== "undefined") {
      if (searchState.insideBoundingBox.length) {
        this.setState({ insideBoundingBox: searchState.insideBoundingBox })
      } else {
        this.setState({ insideBoundingBox: [] })
      }
    }

    if (typeof searchState.sortBy !== "undefined") {
      if (searchState.sortBy) {
        if (searchState.sortBy === index_name + "_price_asc") {
          urls.push("sortby-price-asc")
        }
        if (searchState.sortBy === index_name + "_distance_asc") {
          urls.push("sortby-distance-asc")
        }
        if (searchState.sortBy === index_name + "_most_recent") {
          urls.push("sortby-most-recent")
        }
        if (searchState.sortBy === index_name + "_yield_desc") {
          urls.push("higest-yield")
        }
        if (searchState.sortBy === index_name + "_yield_asc") {
          urls.push("lowest-yield")
        }
        this.setState({ sortBy: searchState.sortBy })
      }
    } else if (this.state.sortBy !== "" || this.state.sortbyslug !== "") {
        if (this.state.sortbyslug === "sortby-price-asc")
          localStorage.setItem("sortby-value", index_name + "_price_asc")
        if (this.state.sortbyslug === "sortby-distance-asc")
          localStorage.setItem("sortby-value", index_name + "_distance_asc")
        if (this.state.sortbyslug === "sortby-most-recent")
          localStorage.setItem("sortby-value", index_name + "_distance_asc")
        if (this.state.sortbyslug === "higest-yield")
          localStorage.setItem("sortby-value", index_name + "_yield_desc")
        if (this.state.sortbyslug === "lowest-yield")
          localStorage.setItem("sortby-value", index_name + "_yield_asc")
        urls.push(`${this.state.sortbyslug}`)
        this.setState({ sortBy: localStorage.getItem("sortby-value") })
    }
    const effectivePage =
      typeof searchState.page === "number"
        ? searchState.page
        : this.state.page > 0
        ? this.state.page
        : null

    if ( searchState.query != this.state.query) {
        this.setState({ page: null })
    } else if (effectivePage > 1) {
      urls.push(`page-${effectivePage}`)
      this.setState({ page: effectivePage })
    }

    if (localQuery !== null && isMatched) {
      searchState.query = ""
    } else {
      localStorage.removeItem("searchValue")
      localStorage.removeItem("searchValueFull")
      localStorage.removeItem("searchValueFullName")
    }

    if (window) {
      this.setState({
        searchCounty: window.localStorage.getItem("searchCounty"),
      })
    }
    let url = urls.join("/")
    let newRoute = "/property/for-sale/" + url + "/"
    var url_main = typeof window !== "undefined" ? window.location.pathname : ""
    navigate(newRoute.replace("//", "/"), { replace: true })
  }
  componentDidMount() {
    if (localStorage.getItem("navindex") == "home") {
      $(document).ready(function () {
        $("html, body").scrollTop(0)
      })
    }
    const { params } = this.props
    const searchParams = params["*"].split("/")

    const full_page_url =
      typeof window !== "undefined" ? window.location.pathname : ""
    if (full_page_url == "/property/for-sale/") {
      window.location.href = `/property/for-sale/in-blackwater-newport-isle-of-wight/radius-8-miles/`
    }

    if (full_page_url.startsWith("/property/for-sale/in-")) {
      // check if radius already exists anywhere in the path
      const hasRadius = /\/radius-\d+-miles\/?/.test(full_page_url);
      if (!full_page_url.includes("/in-blackwater-newport-isle-of-wight") && !hasRadius) {
        let redirectUrl = full_page_url.replace(/\/$/, ""); // remove trailing slash
        redirectUrl += "/radius-3-miles/";
        window.location.href = redirectUrl;
      }
    }

    if (window) {
      this.setState({
        searchCounty: window.localStorage.setItem("searchCounty", ""),
      })
    }

    var queryParam = ""
    searchParams.forEach(param => {
      if (param.includes("in-") && !param.includes("chain-")) {
        localStorage.setItem("searchValue", param.replace("in-", ""))
        localStorage.setItem(
          "searchValueFullName",
          hyphenToCaptilize(param.replace("in-", ""))
        )
      }

      if (param.includes("in-") && !param.includes("chain-")) {
        queryParam = param.substring(3)
        this.setState({ query: param.substring(3) })
      }
      if (param.includes("under-")) {
        this.setState({ max: param.substring(6) })
      }
      if (param.includes("over-")) {
        this.setState({ min: (param.substring(5)) })
      }
      if (param.includes("-and-more-bedrooms")) {
        this.setState({ bedrooms: param.split("-")[0], bedrooms_slug: "" })
      }
      if (param.includes("studio")) {
        this.setState({ bedrooms: 0, bedrooms_slug: "studio" })
      }
      if (param.includes("type-")) {
        this.setState({ building: param.replace("type-", "") })
      }
      if (param.includes("page-")) {
        this.setState({ page: Number(param.split("page-")[1]) || 1 })
      }
      if (param.includes("sortby-")) {
        this.setState({ sortbyslug: param })
      }
      if (param.includes("higest-yield")) {
        this.setState({ sortbyslug: "higest-yield" })
      }
      if (param.includes("lowest-yield")) {
        this.setState({ sortbyslug: "lowest-yield" })
      }

      if (param.includes("with-")) {
        var indusArrfilt = param.replace("with-", "")
        var industryVal = indusArrfilt.split("-and-")
        let mapValues = this.props.data?.allPromotion.nodes.map(
          (node, index) => {
            var pro_title = _.lowerCase(node.title)
            node["url"] = pro_title.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-")
            return node
          }
        )

        this.setState({
          property_promotions: mapValues
            .filter(c => industryVal.includes(c.url))
            .map(c => String(c.promo_id)),
        })
        this.setState({ selectedpromotions: indusArrfilt })
      }
      if (param.includes("radius-")) {
        let radius = param.split("-")[1]
        if (!_.isEmpty(queryParam) && radius != "") {
          let selectedArea = isAreaMatch(this.state.areaList, queryParam)
          if (!_.isEmpty(selectedArea) && radius != "") {
            this.setState(
              {
                radius: radius,
                aroundRadius: milesToMeter(radius),
                aroundLatLng: getLatLan(selectedArea),
                getRankingInfo: true,
              },
              () => {
                this.changeStateAndUrl({
                  ...this.state.searchState, // keep all current filters
                  radius: radius, // explicitly pass parsed radius
                  aroundLatLng: getLatLan(selectedArea),
                  aroundRadius: milesToMeter(radius),
                  getRankingInfo: true,
                })
              }
            )
          } else {
            this.setState({ algoliaConfig: initConf })
          }
        } else {
          this.setState({ algoliaConfig: initConf })
        }
      }

      if (param.includes("between-")) {
        this.setState({
          min: param.split("-")[1],
          max: param.split("-")[3],
        })
      }
    })

    if (sessionStorage.getItem("MainView") == "Grid") {
      this.setState({ mapView: true })
    }

    $(document).mouseup(function (e) {
      var container = $(".dropdown-exp")
      var containerdiv = $(".more-filter-select")

      if (
        !containerdiv.is(e.target) &&
        containerdiv.has(e.target).length === 0
      ) {
        $(".dropdown-exp").removeClass("active")
      }
    })

    this.setState({ isReady: true })// allow Algolia only after setup
  }

  changeToMapUrl = () => {
    this.setState({ mapView: true })
    localStorage.setItem("map-hits", JSON.stringify([]))
    localStorage.setItem("map-bounds", "")
  }
  changeToListUrl = () => {
    this.setState({ mapView: false })
  }

  changeRadius = radius => {
    if (radius != "") {
      var radius_query = this.state.searchState.query
      if (typeof radius_query == "undefined") {
        radius_query = this.state.query
      }
      this.setState({ radius, query: radius_query }, () => {
        this.changeStateAndUrl(this.state.searchState)
      })
    } else {
      this.setState({ radius: 3 }, () => {
        this.changeStateAndUrl(this.state.searchState)
      })
    }
  }

  render() {
    var search_area = ""
    var price_range = "",
      property_type = "",
      bedrooms = "",
      promotion = "",
      promotion_text = "",
      radius = "",
      radius_text = "",
      page = 1
    var fullarea =
      typeof window !== "undefined" && localStorage
        ? localStorage.getItem("searchValueFullName")
        : ""
    if (this.props.params["*"]) {
      search_area = fullarea
        ? "in " + fullarea
        : this.props.params["*"].split("/").filter(c => c.includes("in"))
            .length > 0
        ? "in " +
          this.props.params["*"]
            .split("/")
            .filter(c => c.includes("in"))[0]
            .split("in-")[1]
            .split("-")
            .map(c => _.upperFirst(c))
            .join(" ")
        : ""

      price_range =
        this.props.params["*"]
          .split("/")
          .filter(
            c =>
              (c.includes("over-") ||
                c.includes("under-") ||
                c.includes("between-")) &&
              !c.includes("dover")
          ).length > 0
          ? this.props.params["*"]
              .split("/")
              .filter(
                c =>
                  (c.includes("over-") ||
                    c.includes("under-") ||
                    c.includes("between-")) &&
                  !c.includes("dover")
              )[0]
              .split("-")
              .map(c => (isNaN(c) ? c : `£${parseInt(c).toLocaleString()}`))
              .join(" ")
          : ""

      property_type =
        this.props.params["*"].split("/").filter(c => c.includes("type-"))
          .length > 0
          ? this.props.params["*"]
              .split("/")
              .filter(c => c.includes("type-"))[0]
              .split("type-")
              .map(c => _.upperFirst(c))[1]
          : ""

      radius =
        this.props.params["*"].split("/").filter(c => c.includes("radius-"))
          .length > 0
          ? this.props.params["*"]
              .split("/")
              .filter(c => c.includes("radius-"))[0]
              .split("radius-")
              .map(c => _.upperFirst(c))[1]
          : ""

      bedrooms =
        this.props.params["*"]
          .split("/")
          .filter(c => c.includes("-and-more-bedrooms")).length > 0
          ? this.props.params["*"]
              .split("/")
              .filter(c => c.includes("-and-more-bedrooms"))[0]
              .split("-and-more-bedrooms")[0]
          : ""

      promotion =
        this.props.params["*"].split("/").filter(c => c.includes("with-"))
          .length > 0
          ? this.props.params["*"]
              .split("/")
              .filter(c => c.includes("with-"))[0]
              .split("-")
              .join(" ")
          : ""

      page =
        this.props.params["*"].split("/").filter(c => c.includes("page-"))
          .length > 0
          ? Number(
              this.props.params["*"]
                .split("/")
                .filter(c => c.includes("page-"))[0]
                .split("page-")
                .map(c => c)[1]
            )
          : 1

      property_type = property_type.replace("property", "properties")
      if (
        property_type &&
        property_type.charAt(property_type.length - 1) != "s"
      ) {
        property_type = property_type + "s"
      }

      promotion_text = _.startCase(_.toLower(promotion)).replace("With", "with")

      radius_text = "within " + radius.replace("-", " ")
    }

    var h1 =
      price_range !== "" && property_type !== "" && bedrooms !== ""
        ? `${property_type.replace(
            "-",
            " "
          )} for Sale ${search_area} with more than ${bedrooms} Bedrooms ${price_range}`
        : property_type !== "" && bedrooms !== ""
        ? `${property_type.replace(
            "-",
            " "
          )} for Sale ${search_area} with more than ${bedrooms} Bedrooms`
        : price_range !== "" && bedrooms !== ""
        ? `Properties for Sale ${search_area} with more than ${bedrooms} Bedrooms ${price_range}`
        : price_range !== "" && property_type !== ""
        ? `${property_type.replace(
            "-",
            " "
          )} for Sale ${search_area} ${price_range}`
        : bedrooms !== ""
        ? `Properties for Sale ${search_area} with more than ${bedrooms} Bedrooms`
        : property_type !== ""
        ? `${property_type.replace("-", " ")} for Sale ${search_area}`
        : price_range !== ""
        ? `Properties for Sale ${search_area} ${price_range}`
        : `Properties for Sale ${search_area}`

    property_type = _.lowerFirst(property_type)

    var desc =
      search_area == "in Blackwater, Newport, Isle of Wight"
        ? `Explore our latest collection of properties for sale ${search_area}. Contact Pittis estate agents ${search_area} to find the right properties for you.`
        : `Explore our range of properties for sale ${search_area}. Contact our properties experts to find the right properties for sale in ${search_area}.`
    if (
      price_range !== "" &&
      property_type !== "" &&
      bedrooms !== "" &&
      radius !== ""
    ) {
      desc = `Explore ${bedrooms} bedroom ${property_type.replace(
        "-",
        " "
      )} for sale ${search_area} ${price_range} ${radius_text} available with Pittis. Contact one of our estate agents for assistance in finding your properties ${search_area}.`
    } else if (property_type !== "" && bedrooms !== "" && radius !== "") {
      desc = `Find the latest ${property_type.replace(
        "-",
        " "
      )} for sale ${search_area} with more than ${bedrooms} bedrooms ${radius_text}. Contact Pittis estate agents and letting agents ${search_area}, to arrange a viewing.`
    } else if (property_type !== "" && price_range !== "" && radius !== "") {
      desc = `Check out the latest collection of ${property_type.replace(
        "-",
        " "
      )} for sale ${search_area} ${price_range} ${radius_text} with Pittis estate agents ${search_area}.`
    } else if (price_range !== "" && property_type !== "" && bedrooms !== "") {
      desc = `Check out the latest collection of ${property_type.replace(
        "-",
        " "
      )} for sale ${search_area} with more than ${bedrooms} bedrooms ${price_range} with Pittis estate agents ${search_area}.`
    } else if (property_type !== "" && radius !== "") {
      desc = `Locate the best ${property_type.replace(
        "-",
        " "
      )} for sale ${search_area} ${radius_text}. Book an appointment with Pittis estate agents ${search_area} to get assistance.`
    } else if (property_type !== "" && bedrooms !== "") {
      desc = `Find the latest ${property_type.replace(
        "-",
        " "
      )} for sale ${search_area} with more than ${bedrooms} bedrooms. Contact Pittis estate agents and letting agents ${search_area}, to arrange a viewing.`
    } else if (price_range !== "" && radius !== "") {
      desc = `Identify the properties for sale ${search_area} ${price_range} ${radius_text}. Book a viewing with Pittis estate agents ${search_area}.`
    } else if (bedrooms !== "" && radius !== "") {
      desc = `Explore properties for sale ${search_area} with more than ${bedrooms} bedrooms ${radius_text} here. Contact our expert estate agents today to get assistance in finding the right properties ${search_area}.`
    } else if (price_range !== "" && bedrooms !== "") {
      desc = `Explore the list of properties for sale ${search_area} with more than ${bedrooms} bedrooms ${price_range} with Pittis and request a viewing for the properties that interests you.`
    } else if (price_range !== "" && property_type !== "") {
      desc = `Check out the latest collection of ${property_type.replace(
        "-",
        " "
      )} for sale ${search_area} ${price_range} with Pittis estate agents ${search_area}.`
    } else if (radius !== "") {
      desc = `Identify the best properties for sale ${search_area} ${radius_text}. Book an appointment with Pittis estate agents ${search_area}.`
    } else if (price_range !== "") {
      desc = `Locate the right properties for sale ${search_area} ${price_range} with Pittis estate agents. Book an appointment with one of our properties experts ${search_area}.`
    } else if (bedrooms !== "") {
      desc = `Explore properties for sale ${search_area} with more than ${bedrooms} bedrooms here. Contact our expert estate agents today to get assistance in finding the right properties ${search_area}.`
    } else if (property_type !== "") {
      desc = `Looking for a ${property_type.replace(
        "-",
        " "
      )} for sale ${search_area}? Pittis estate agents are here to help. `
    }

    var intro_copy = `Discover a wide range of ${_.lowerFirst(
      h1.replace("Properties", "properties").replace("Sale", "sale")
    )} ${
      promotion ? _.replace(promotion_text, new RegExp("And", "g"), "and") : ""
    } ${
      radius ? radius_text : ""
    } with Pittis Estate Agents. To filter these results, use our filter above, or for more information about ${
      property_type
        ? property_type.replace("-", " ").toLowerCase()
        : "properties"
    } ${search_area}, please `

    return (
      <>
        <SeoResult
          title={`${h1} ${
            promotion
              ? _.replace(promotion_text, new RegExp("And", "g"), "and")
              : ""
          } ${radius ? radius_text.replace("miles", "Miles") : ""}`}
          county={this.state.searchCounty}
          description={desc}
        />
        <SearchTemplate
          {...this.state}
          changeStateAndUrl={this.changeStateAndUrl}
          changeToMapUrl={this.changeToMapUrl}
          changeToListUrl={this.changeToListUrl}
          changeRadius={this.changeRadius}
          location={this.props.location}
          search_area={search_area}
          h1={`${h1} ${
            promotion
              ? _.replace(promotion_text, new RegExp("And", "g"), "and")
              : ""
          } ${radius ? radius_text.replace("miles", "Miles") : ""}`}
          desc={`${intro_copy}`}
          page={page}
          promotion={promotion}
          property_type={property_type}
          search_type="sales"
        />
      </>
    )
  }
}

export default Search

export const pageQuery = graphql`
  query {
    allArea {
      nodes {
        id
        name
        latitude
        longitude
        districtCountyTown
      }
    }
    allPromotion {
      nodes {
        id
        name
        title
        promo_id
      }
    }
  }
`